module.exports = __webpack_public_path__ + "img/24.d97848e0.png";